import { render } from "./GetAllCMDOfAnApp.vue?vue&type=template&id=f973c03c"
import script from "./GetAllCMDOfAnApp.vue?vue&type=script&lang=js"
export * from "./GetAllCMDOfAnApp.vue?vue&type=script&lang=js"
script.render = render

export default script